// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M7 2H17V5H20V9H4V5H7V2Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 13V11H2V13H3V20H2V22H8V16H16V22H22V20H21V13H22Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M14 22H10V18H14V22Z"}}]};

const BuildingFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'building-filled',
    ref,
    icon: element,
  },
));

BuildingFilledIcon.displayName = 'BuildingFilledIcon';

export default BuildingFilledIcon;
